import { Component, CUSTOM_ELEMENTS_SCHEMA, DestroyRef, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { SupportedLanguages } from '@shs-digi-care-monorepo/interfaces';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-language-switcher',
    templateUrl: './language-switcher.component.html',
    imports: [TranslateModule, RouterModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LanguageSwitcherComponent implements OnInit {
    private readonly translate = inject(TranslateService);
    private readonly destroyRef = inject(DestroyRef);

    protected supportedLanguages = [SupportedLanguages.EN];
    protected currentLang: WritableSignal<string> = signal('en');
    protected flagMap: Record<SupportedLanguages, string> = {
        [SupportedLanguages.EN]: '/assets/images/flags/us.svg',
        [SupportedLanguages.DE]: '/assets/images/flags/de.svg',
        [SupportedLanguages.NL]: '/assets/images/flags/nl.svg',
        [SupportedLanguages.TR]: '/assets/images/flags/tr.svg'
    };

    public ngOnInit(): void {
        this.currentLang.set(this.translate.currentLang || 'en');
        this.listenForLanguageChanges();
    }

    protected changeLanguage(langCode: string): void {
        this.translate.use(langCode);
        this.currentLang.set(langCode);
    }

    private listenForLanguageChanges(): void {
        this.translate.onLangChange
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((event) => this.currentLang.set(event.lang));
    }
}
